import {
  Directive,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  OnDestroy,
  OnInit,
  Output
} from "@angular/core";
import {
  DetachedDomElementService,
  DetachedElementRef
} from "src/app/services/detached-dom-element.service";
import { EditorOptions as TinyEditorOptions, Editor } from "tinymce";
import { initWysiwygEditor } from "src/app/support/tiny";

@Directive({
  selector: "[tinyeditor]",
  standalone: false
})
export class TinyEditorDirective implements OnInit, OnDestroy {
  @Input()
  init: Partial<TinyEditorOptions> | undefined;

  @Input()
  maxImageSize?: number;

  @Input()
  containerMode: "detached" | "inside" = "detached";

  @Input()
  readOnly: boolean = false;

  @Output()
  contentChanged: EventEmitter<void> = new EventEmitter<void>();

  private detachedDomElementService: DetachedDomElementService = inject(
    DetachedDomElementService
  );
  private elementRef: ElementRef<HTMLElement> = inject(ElementRef);

  private editor: Editor | undefined;

  private detachedElementRef: DetachedElementRef | undefined;

  async ngOnInit(): Promise<void> {
    let tinyContainer: HTMLElement | undefined;

    switch (this.containerMode) {
      case "detached": {
        this.detachedElementRef = this.detachedDomElementService.install(
          this.elementRef!.nativeElement
        );

        tinyContainer = document.createElement("div");
        this.detachedElementRef.element.appendChild(tinyContainer);
        break;
      }
      case "inside": {
        tinyContainer = this.elementRef!.nativeElement;
        break;
      }
    }

    if (this.init) {
      this.init.readonly = this.readOnly;
    } else {
      this.init = {
        readonly: this.readOnly
      };
    }

    this.editor = await initWysiwygEditor(
      tinyContainer!,
      () => {
        this.contentChanged.emit();
      },
      this.init,
      undefined,
      {
        imageMaxSize: this.maxImageSize
      }
    );
  }

  ngOnDestroy(): void {
    this.destroied();
  }

  getContent(): string | undefined {
    return this.editor?.getContent();
  }

  activated(): void {
    if (this.detachedElementRef) {
      this.detachedDomElementService.show(this.detachedElementRef.uuid);
    }
  }

  decativated(): void {
    if (this.detachedElementRef) {
      this.detachedDomElementService.hide(this.detachedElementRef.uuid);
    }
  }

  destroied(): void {
    this.editor?.destroy(false);
    this.editor = undefined;
    if (this.detachedElementRef) {
      this.detachedDomElementService.destory(this.detachedElementRef.uuid);
    }
  }
}
